<template>
  <div>
    <div class="modal-user">
      <div
        style="text-align: right"
        class="modal-close"
        @click="closeModal">&#10006;</div>
      <div>
        <h3 class="modal-title text-center mb-3">Add user</h3>
      </div>
      <div>
        <form
          ref="add_user_form"
          @submit.prevent="addAdminUser"
          @keydown="form.onKeydown($event)">
          <!-- Name -->
          <div class="form-group mb-3 row">
            <label class="col-md-3 col-form-label text-md-end">Name</label>
            <div class="col-md-7">
              <input
                v-model="form.name"
                :class="{ 'is-invalid': form.errors.has('name') }"
                class="form-control"
                type="text"
                name="name">
              <has-error
                :form="form"
                field="name"/>
            </div>
          </div>

          <!-- Email -->
          <div class="form-group mb-3 row">
            <label class="col-md-3 col-form-label text-md-end">Email</label>
            <div class="col-md-7">
              <input
                v-model="form.email"
                :class="{ 'is-invalid': form.errors.has('email') }"
                class="form-control"
                type="email"
                name="email">
              <has-error
                :form="form"
                field="email"/>
            </div>
          </div>

          <!-- Password -->
          <div class="form-group mb-3 row">
            <label class="col-md-3 col-form-label text-md-end">Password</label>
            <div class="col-md-7">
              <input
                v-model="form.password"
                :class="{ 'is-invalid': form.errors.has('password') }"
                class="form-control"
                type="password"
                name="password">
              <has-error
                :form="form"
                field="password"/>
            </div>
          </div>

          <!-- Password Confirmation -->
          <div class="form-group mb-3 row">
            <label class="col-md-3 col-form-label text-md-end">Confirm Password</label>
            <div class="col-md-7">
              <input
                v-model="form.password_confirmation"
                :class="{ 'is-invalid': form.errors.has('password_confirmation') }"
                class="form-control"
                type="password"
                name="password_confirmation">
              <has-error
                :form="form"
                field="password_confirmation"/>
            </div>
          </div>
          <div class="modal-footer border-0">
            <div class="col-md-4 col-sm-4 ml-md-auto text-md-end">
              <!-- Submit Button -->
              <v-button :loading="form.busy">
                Register
              </v-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "vform";
import Swal from "sweetalert2";
import {mapActions} from "vuex";
import profileMixin from "../../../mixins/profileMixin";

export default {
  mixins: [profileMixin],
  data: () => ({
    form: new Form({
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
    }),
  }),

  methods: {
      ...mapActions(['adminAddUsers']),
    closeModal: function () {
      this.showModal(false)
    },
    addAdminUser() {
      return this.adminAddUsers(this.form).then(() => {
        Swal.fire(
            'Successfully!',
            'User added successfully.',
            'success'
        ).then(() => {
          this.form.name = ''
          this.form.email = ''
          this.form.password = ''
          this.form.password_confirmation = ''
          this.$refs.modal_add.show = false
        });
      }).catch((error) => {
        console.log('error', error);
      });
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modals/AdminModals/AddUserModal.vue